// // import React from "react";
// // import ServiceCard from "../ServiceCard/ServiceCard";
// // import "./Services.css";

// // const Services = () => {
// //   const services = [
// //     {
// //       id: 1,
// //       title: "Company Formation",
// //       description:
// //         "Company Formation, Business Registration, VAT, Payroll, Annual Accounts, Corporate Services",
// //       icon: "fas fa-building",
// //     },
// //     {
// //       id: 2,
// //       title: "Book Keeping ",
// //       description: "Book keeping, Payroll, Umbrella Company",
// //       icon: "fas fa-user-md",
// //     },
// //     {
// //       id: 3,
// //       title: "Self Employed",
// //       description: "Self Employed, Landlords, IT & Tech Form 11",
// //       icon: "fas fa-user-tie",
// //     },
// //     {
// //       id: 4,
// //       title: "Tax Refunds",
// //       description: "Tax Refunds. No refund no fee. 4 years",
// //       icon: "fas fa-euro-sign",
// //     },
// //     {
// //       id: 5,
// //       title: "IT Contractors",
// //       description:
// //         "IT, Software Developers, Pharma & Big Tech Contractors, Payroll, Umbrella Company",
// //       icon: "fas fa-laptop-code",
// //     },
// //   ];

// //   return (
// //     <section className="services section bg-light" id="services">
// //       <div className="container">
// //         <h2 className="section-title">our services</h2>
// //         <p className="section-subtitle">
// //           click more info under the service that applies to you and lets get
// //           started
// //         </p>

// //         <div className="services-grid">
// //           {services.map((service) => (
// //             <ServiceCard
// //               key={service.id}
// //               id={service.id}
// //               title={service.title}
// //               description={service.description}
// //               icon={service.icon}
// //             />
// //           ))}
// //         </div>
// //       </div>
// //     </section>
// //   );
// // };

// // export default Services;

// import React from "react";
// import "./Services.css";

// const Services = () => {
//   const services = [
//     {
//       title: "Tax Consultation",
//       description:
//         "Professional tax planning and compliance services …more",
//       icon: "fa-solid fa-file-invoice-dollar",
//     },
//     {
//       title: "Company Formation",
//       description:
//         "Start your company easily with our expert registration and compliance services.",
//       icon: "fa-solid fa-building",
//     },
//     {
//       title: "Accounting Services",
//       description:
//         "Complete bookkeeping and accounting support for small businesses and contractors.",
//       icon: "fa-solid fa-calculator",
//     },
//     {
//       title: "VAT Registration",
//       description:
//         "Expert assistance in VAT registration and compliance across Ireland.",
//       icon: "fa-solid fa-percent",
//     },
//     {
//       title: "Payroll Management",
//       description:
//         "Efficient payroll solutions ensuring compliance and timely payments.",
//       icon: "fa-solid fa-money-check-dollar",
//     },
//     {
//       title: "Business Advisory",
//       description:
//         "Strategic financial and operational advice to help your business grow.",
//       icon: "fa-solid fa-chart-line",
//     },
//   ];

//   const scrollToWhatWeDo = () => {
//     const section = document.getElementById("what-we-do");
//     if (section) {
//       section.scrollIntoView({ behavior: "smooth" });
//     }
//   };

//   return (
//     <section className="services section" id="services">
//       <div className="container">
//         <div className="services-header">
//           <h2>our services</h2>
//           <p>
//             We provide a wide range of taxation, accounting and advisory
//             services designed to help individuals and businesses succeed.
//           </p>
//         </div>

//         <div className="services-grid">
//           {services.map((service, index) => (
//             <div key={index} className="services-card">
//               <div className="services-icon">
//                 <i className={service.icon}></i>
//               </div>

//               <h3>{service.title}</h3>

//               <p>{service.description}</p>

//               {/* <button className="service-btn" onClick={scrollToWhatWeDo}>
//                 More Info →
//               </button> */}
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Services;

import React, { useState } from "react";
import "./Services.css";

const Services = () => {
  const [expandedCards, setExpandedCards] = useState({});

  const services = [
    {
      title: "Tax Consultation",
      description:
        "Professional tax planning and compliance services for individuals ...",
      icon: "fa-solid fa-file-invoice-dollar",
      expandedContent: {
        details:
          "Professional tax planning and compliance services for individuals, self-employed professionls, and SMEs. We provide support with PAYE, self-assessment tax returns, Revenue requirements, and tax obligations. Our team helps clients manage their taxes efficiently while ensuring accuracy and compliance with Irish tax regulations. We deliver practical tax solutions tailored to your personal and business needs.",
      },
    },
    {
      title: "Company Formation",
      description:
        "Start your business with confidence through our complete company formation ...",
      icon: "fa-solid fa-building",
      expandedContent: {
        details:
          "Start your business with confidence through our complete company formation and compliance support. We assist with CRO company registration, Revenue ROS registration, tax registrations, business bank account setup, and all essential compliance requirements. Whether you are a start-up, self-employed individual, or SME, we help you establish your business correctly and efficiently from the beginning.",
      },
    },
    {
      title: "Accounting Services",
      description:
        "We provide reliable bookkeeping, reconciliations, and full ...",
      icon: "fa-solid fa-calculator",
      expandedContent: {
        details:
          "We provide reliable bookkeeping, reconciliations, and full accounts submission for SMEs and selfemployed individuals. Our service ensures your financial records are accurate, compliant, and always up to date, giving you the confidence to focus on running your business while we take care of the numbers.",
      },
    },
    {
      title: "VAT Registration",
      description:
        "We provide precise VAT registration and compliance support ...",
      icon: "fa-solid fa-percent",
      expandedContent: {
        details:
          "We provide precise VAT registration and compliance support for businesses across Ireland. Our team manages accurate VAT calculations, prepares audit supportive records, and ensures timely return submissions. With clear guidance on regulatory requirements and precise documentation, we help you stay fully compliant while keeping your financial operations running efficiently.",
      },
    },
    {
      title: "Payroll Management",
      description:
        "Professional tax planning and compliance services for individuals ...",
      icon: "fa-solid fa-money-check-dollar",
      expandedContent: {
        details:
          "Our comprehensive payroll management services ensure your employees are paid accurately and on time. We handle all aspects of payroll processing, tax calculations, and statutory compliance, providing peace of mind and administrative efficiency for your business.",
      },
    },
  ];

  const toggleExpand = (index) => {
    setExpandedCards((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const scrollToWhatWeDo = () => {
    const section = document.getElementById("what-we-do");
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="services section" id="services">
      <div className="container">
        <div className="services-header">
          <h2>our services</h2>
          <p>
            We provide a wide range of taxation, accounting and advisory
            services designed to help individuals and businesses succeed.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => {
            const isExpanded = expandedCards[index] || false;

            return (
              <div
                key={index}
                className={`services-card ${isExpanded ? "expanded" : ""}`}
              >
                <div className="services-icon">
                  <i className={service.icon}></i>
                </div>

                <h3>{service.title}</h3>

                <p className="service-description">{service.description}</p>

                {/* EXPANDED CONTENT - Only details */}
                {isExpanded && (
                  <div className="expanded-content">
                    <p className="expanded-details">
                      {service.expandedContent.details}
                    </p>
                  </div>
                )}

                {/* MORE BUTTON */}
                <button
                  className="service-more-btn"
                  onClick={() => toggleExpand(index)}
                >
                  {isExpanded ? "Less ▲" : "More..."}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
